(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cova-academy-drill-library"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('[data-cova-drill-library]').forEach((library) => {

  if (library.dataset.initialized === 'true') return;

  const search = library.querySelector('[data-drill-search]');

  const level = library.querySelector('[data-drill-level]');

  const objective = library.querySelector('[data-drill-objective]');

  const stage = library.querySelector('[data-drill-stage]');

  const reset = library.querySelector('[data-drill-reset]');

  const count = library.querySelector('[data-drill-count]');

  const empty = library.querySelector('[data-drill-empty]');

  const grid = library.querySelector('[data-drill-grid]');

  const status = library.querySelector('[data-drill-sync-status]');

  if (!search || !level || !objective || !stage || !count || !empty || !grid) return;

  library.dataset.initialized = 'true';

  const node = (tag, className, text) => {

    const el = document.createElement(tag);

    if (className) el.className = className;

    if (text !== undefined) el.textContent = text;

    return el;

  };

  const populate = (select, values, allLabel) => {

    const options = [node('option', '', allLabel)];

    options[0].value = 'all';

    Array.from(new Set(values.filter(Boolean))).sort((a,b) => a.localeCompare(b)).forEach(value => {

      const option = node('option', '', value); option.value = value; options.push(option);

    });

    select.replaceChildren(...options); select.value = 'all';

  };

  const paragraph = (title, text) => {

    if (!text) return null;

    const section = node('section');

    section.append(node('h3', '', title), node('p', 'cova-drills__plain', text));

    return section;

  };

  const safeLink = (label, value) => {

    if (!value) return null;

    try {

      const url = new URL(value);

      if (url.protocol !== 'https:') return null;

      const link = node('a', '', label + ' (opens in a new tab)');

      link.href = url.href; link.target = '_blank'; link.rel = 'noopener noreferrer';

      return link;

    } catch { return null; }

  };

  const stageLabels = {

    'development-stage-1': 'Stage 1 · Initial assessment',

    'development-stage-2': 'Stage 2 · Topspin development',

    'development-stage-3': 'Stage 3 · Baseline drop-feeding',

    'development-stage-4': 'Stage 4 · Hand-feeding integration',

    'development-stage-5': 'Stage 5 · Advanced feeding',

    'development-stage-6': 'Stage 6 · Tactical preparation'

  };

  const stagesFor = tags => Array.from(new Set(

    (tags || '').toLowerCase().match(/\bdevelopment-stage-[1-6]\b/g) || []

  ));

  const data = library.querySelector('[data-drill-sync-data]');

  if (data) {

    try {

      const payload = JSON.parse(data.textContent);

      if (payload.schema_version !== 1 || !Array.isArray(payload.drills)) throw new Error('Invalid data');

      const ids = new Set();

      payload.drills.forEach(d => {

        if (!d || typeof d.id !== 'string' || !d.id || typeof d.title !== 'string' || !d.title || ids.has(d.id)) throw new Error('Invalid drill');

        ids.add(d.id);

        Object.values(d).forEach(v => { if (typeof v !== 'string') throw new Error('Invalid field'); });

      });

      const fragment = document.createDocumentFragment();

      payload.drills.forEach((d,index) => {

        const card = node('details', 'cova-drills__card');

        card.dataset.drillCard = ''; card.dataset.level = d.format || ''; card.dataset.objective = d.category || '';

        card.dataset.stage = stagesFor(d.tags).join(' ');

        card.dataset.search = Object.values(d).join(' ').toLowerCase();

        const summary = node('summary'); const row = node('div'); const heading = node('div');

        heading.append(node('h2','',d.title), node('p','',d.objective || ''));

        const badges = node('div', 'cova-drills__badges');

        [d.category, d.format, ...stagesFor(d.tags).map(key => stageLabels[key])].filter(Boolean).forEach(label => {

          badges.append(node('span', 'cova-drills__badge', label));

        });

        heading.append(badges);

        row.append(node('span','cova-drills__number',String(index+1)),heading);

        const toggle = node('span','cova-drills__toggle','+'); toggle.setAttribute('aria-hidden','true');

        summary.append(row,toggle); card.append(summary);

        const details = node('div','cova-drills__details'); const meta = node('div','cova-drills__meta');

        [['Category',d.category],['Players',d.players],['Format',d.format],['Drill ID',d.id]].forEach(([label,value]) => {

          const item = node('span'); item.append(node('strong','',label),document.createTextNode(value || 'Not specified')); meta.append(item);

        });

        const body = node('div','cova-drills__body');

        [['Subcategory',d.subcategory],['Primary skills',d.skills],['Setup',d.setup],['How it works',d.instructions],['Scoring / completion',d.scoring],['Coaching focus',d.coaching_focus],['Key concept',d.key_concept],['Variations',d.variations],['Tags',d.tags]].forEach(([title,text]) => {

          const section = paragraph(title,text); if (section) body.append(section);

        });

        const media = node('section'); media.append(node('h3','','Video and diagram'));

        [safeLink('Open video',d.video_url),safeLink('Open diagram',d.diagram_url)].forEach(link => {

          if (link) { const p = node('p'); p.append(link); media.append(p); }

        });

        if (media.children.length > 1) body.append(media);

        details.append(meta,body); card.append(details); fragment.append(card);

      });

      grid.replaceChildren(fragment);

      level.previousElementSibling.textContent = 'Format';

      objective.previousElementSibling.textContent = 'Category';

      populate(level,payload.drills.map(d=>d.format),'All formats');

      populate(objective,payload.drills.map(d=>d.category),'All categories');

      const date = new Date(payload.synced_at);

      if (status) status.textContent = 'From the CoVA drill spreadsheet' + (Number.isNaN(date.getTime()) ? '.' : ' · Last synced ' + date.toLocaleString());

    } catch {

      if (status) status.textContent = 'The synced library could not be displayed. Showing the saved drills; contact the academy administrator.';

    }

  }

  const cards = Array.from(library.querySelectorAll('[data-drill-card]'));

  const update = () => {

    const term = search.value.trim().toLowerCase(); let visible = 0;

    cards.forEach(card => {

      const show = (!term || (card.dataset.search || '').includes(term))

        && (level.value === 'all' || card.dataset.level === level.value)

        && (objective.value === 'all' || card.dataset.objective === objective.value)

        && (stage.value === 'all' || (card.dataset.stage || '').split(' ').includes(stage.value));

    card.hidden = !show; if (show) visible++;

    });

    count.textContent = `${visible} ${visible === 1 ? 'drill' : 'drills'} shown`;

    empty.hidden = visible !== 0;

  };

  search.addEventListener('input',update); level.addEventListener('change',update); objective.addEventListener('change',update);

  stage.addEventListener('change',update);

  reset?.addEventListener('click',()=>{ search.value=''; level.value='all'; objective.value='all'; stage.value='all'; update(); });

  update();

});


  } catch(e) { console.error(e); }
})();
})();
